import { ChangeDetectorRef, Component, type OnDestroy, type OnInit, ViewChild } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { ActivatedRoute, type Params, Router, RouterModule } from '@angular/router'
import {
  type User
} from '@inside-hub-app/customer-portal-b2c-client'
import { KeycloakService } from '@emilfreydigital/keycloak-angular'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { NGXLogger } from 'ngx-logger'
import { type ParsedToken } from '../../../../models/keycloak'
import { DataService } from '../../../services/data.service'
import { LocalStorageService } from '../../../services/local-storage.service'
import { ResizeService, CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import { SharedService, type Tab } from '../../../services/shared.service'
import { VehicleTab, type VehicleDTOExtended } from '../../../services/vehicles.service'
import { RevolutionVehicleDealersComponent } from '../revolution-vehicle-dealers/revolution-vehicle-dealers.component'
import { VehicleBasicDetailsComponent } from '../vehicle-details/vehicle-basic-details/vehicle-basic-details.component'
import { RevolutionVehicleDocumentsComponent } from '../vehicle-documents/vehicle-documents.component'
import { VehicleImagesComponent } from '../vehicle-images/vehicle-images.component'
import {
  type CustomerPortalConfig, type Navigation
} from '@inside-hub-app/customer-portal-config'

import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
import { VehicleTrackTraceComponent } from '../vehicle-track-trace/vehicle-track-trace.component'
import { FAQCardComponent } from '../content/faq-card/faq-card.component'
import { VehicleEquipmentComponent } from '../vehicle-details/vehicle-equipment/vehicle-equipment.component'
import { VehicleExtendedDetailsComponent } from '../vehicle-details/vehicle-extended-details/vehicle-extended-details.component'
import { VehicleEnergyComponent } from '../vehicle-details/vehicle-energy/vehicle-energy.component'
import { NearestFuelStationComponent } from '../vehicle-general/nearest-fuel-station/nearest-fuel-station.component'
import { VehicleRemindersComponent } from '../vehicle-general/vehicle-reminders/vehicle-reminders.component'
import { VehiclLastActionServiceComponent } from '../vehicle-general/vehicle-last-action-service/vehicle-last-action-service.component'
import { RevolutionTyreMoleculeComponent } from '../vehicle-general/tyre-molecule/tyre-molecule.component'
import { FuelPriceComparisonComponent } from '../vehicle-general/fuel-price-comparison/fuel-price-comparison.component'
import { VehicleServicePackageAndInsuranceComponent } from '../vehicle-general/vehicle-service-package-and-insurance/vehicle-service-package-and-insurance.component'
import { VehicleLeasingAndWarrantyComponent } from '../vehicle-general/vehicle-leasing-and-warranty/vehicle-leasing-and-warranty.component'
import { VehicleOnlineShopLinkComponent } from '../vehicle-general/vehicle-online-shop-link/vehicle-online-shop-link.component'
import { TradeMoleculeComponent } from '../vehicle-general/trade-molecule/trade-molecule.component'
import { ArrayContainsPipe } from '../../../pipes/array-contains-pipe'
@Component({
  selector: 'customer-portal-app-revolution-vehicle-details-view',
  standalone: true,
  templateUrl: './vehicle-details-view.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule,
    RevolutionVehicleDocumentsComponent,
    VehicleImagesComponent,
    VehicleTrackTraceComponent,
    RevolutionVehicleDealersComponent,
    FAQCardComponent,
    VehicleBasicDetailsComponent,
    VehicleEquipmentComponent,
    VehicleExtendedDetailsComponent,
    VehicleEnergyComponent,
    NearestFuelStationComponent,
    VehicleRemindersComponent,
    VehiclLastActionServiceComponent,
    RevolutionTyreMoleculeComponent,
    FuelPriceComparisonComponent,
    VehicleServicePackageAndInsuranceComponent,
    VehicleLeasingAndWarrantyComponent,
    VehicleOnlineShopLinkComponent,
    TradeMoleculeComponent,
    ArrayContainsPipe
  ]
})
export class VehicleDetailsViewComponent implements OnInit, OnDestroy {
  public hasWarranty
  public enableEfitData
  public hasVehicleOnlineShop

  loadingDealers: boolean
  dealerLoading = true
  error = false
  errorMessage: string
  token: ParsedToken
  user: User
  vehicles: VehicleDTOExtended[] = []
  public vehicle: VehicleDTOExtended = null
  public loading = true
  public vin: string
  i = 0
  public country: string
  public hasNewFooter
  public hasTracking
  public hasNearestFuelStation

  hasFAQ
  currentTab: Tab
  urlParams: Params
  homepage
  notifications
  vehicleNotifications

  navigationItems: Navigation[]

  sub = {
    onLocalStorageDataChanged: null,
    onVehicleNotificationsLoadedSub: null,
    onUserVehiclesLoaded: null,
    onVehicleDealersLoadedSub: null,
    activatedRoute: null,
    tires: null,
    recalls: null,
    tireAppointments: null,
    warranty: null,
    servicePackage: null,
    onUserLoaded: null,
    onResizePx: null,
    geolocation: null,
    fuelPrices: null
  }

  fuelPrices
  leasingWarrantySPLoaded = false
  maintenanceLoaded = false
  loadingTires = true
  loadingRecalls = true
  loadingTireAppointments = true
  loadingWarranty = true
  loadingServicePackage = true
  @ViewChild(VehicleBasicDetailsComponent)
  public VehicleDetails: VehicleBasicDetailsComponent

  @ViewChild(RevolutionVehicleDocumentsComponent)
  public VehicleDocuments: RevolutionVehicleDocumentsComponent

  @ViewChild(VehicleImagesComponent)
  public VehicleImages: VehicleImagesComponent

  @ViewChild(RevolutionVehicleDealersComponent)
  public VehicleDealers: RevolutionVehicleDealersComponent

  nearestFuelStationTypes = ['gas', 'electro', 'hybrid']

  swipeData = {
    currentTab: null,
    swipeCoord: null,
    swipeTime: null,
    tabsCount: null
  }

  tabs: Record<number, VehicleTab> = {
    0: VehicleTab.GENERAL,
    1: VehicleTab.DETAILS,
    2: VehicleTab.DEALER,
    3: VehicleTab.VEHICLE_HISTORY,
    4: VehicleTab.GALLERY,
    5: VehicleTab.TRACKING
  }

  showMobileView: boolean
  public screenSizePx: number
  location
  constructor (
    private readonly keycloak: KeycloakService,
    private readonly route: ActivatedRoute,
    private readonly dataService: DataService,
    private readonly logger: NGXLogger,
    private readonly router: Router,
    private readonly dialog: MatDialog,
    public readonly sharedService: SharedService,
    private readonly localStorageService: LocalStorageService,
    public resizeService: ResizeService,
    private readonly cdf: ChangeDetectorRef,
    private readonly remoteConfigService: EfRemoteConfigurationService<CustomerPortalConfig>
  ) {
    this.hasWarranty = this.remoteConfigService.get('warranty.available')
    this.enableEfitData = this.remoteConfigService.get('enableEfitData')
    this.hasVehicleOnlineShop = this.remoteConfigService.get(
      'hasVehicleOnlineShop'
    )
    this.hasNewFooter = this.remoteConfigService.get('hasNewFooter')
    this.hasTracking = this.remoteConfigService.get('hasTracking')
    this.hasNearestFuelStation = this.remoteConfigService.get(
      'hasNearestFuelStation'
    )
    this.hasFAQ = this.remoteConfigService.get('hasFAQ')
    this.homepage = this.remoteConfigService.get('homepage')
    this.navigationItems =
    this.remoteConfigService.getArrayValues('navigationVehicle')

    route.params.subscribe(params => {
      this.urlParams = params
      this.switchRoute(this.urlParams)
    })

    this.sub.onUserLoaded = this.dataService.onUserLoaded.subscribe(user => {
      this.user = user
    })
  }

  ngOnInit (): void {
    this.token = this.keycloak.getKeycloakInstance().tokenParsed as ParsedToken
    this.country = this.remoteConfigService.get('country.code')

    this.sub.activatedRoute = this.route.params.subscribe(params => {
      if (params.vin != null) {
        if (!this.sharedService.isComissionNumber(params.vin)) {
          this.vin = params.vin
          this.setVehicle()
        }
      }
    })

    this.sub.onUserVehiclesLoaded =
      this.dataService.onUserVehiclesLoaded.subscribe(
        (allVehicles: VehicleDTOExtended[]) => {
          this.loading = false
          if (allVehicles.length > 0) {
            this.vehicles = allVehicles
            this.setVehicle()
          }
        },
        error => {
          this.loading = false
          this.error = true
          this.errorMessage = error.statusText
          this.logger.debug(error)
        }
      )

    this.sub.onVehicleDealersLoadedSub =
      this.dataService.onVehicleDealersLoaded.subscribe(value => {
        if (
          this.vehicle != null &&
          value != null &&
          this.vehicle.vin === value.vin
        ) {
          this.vehicle.dealers = value
          this.dealerLoading = false
        }
      })

    this.sub.onLocalStorageDataChanged =
      this.localStorageService.onLocalStorageDataChanged.subscribe(data => {
        this.showDataIsChangedToast(data)
      })

    this.sub.recalls = this.dataService.loading.recalls.subscribe(loading => {
      this.loadingRecalls = loading
      this.checkAllLoaded()
    })
    this.sub.tires = this.dataService.loading.tires.subscribe(loading => {
      this.loadingTires = loading
      this.checkAllLoaded()
    })
    this.sub.tireAppointments =
      this.dataService.loading.tireAppointments.subscribe(loading => {
        this.loadingTireAppointments = loading
        this.checkAllLoaded()
      })
    this.sub.warranty = this.dataService.loading.warranty.subscribe(loading => {
      this.loadingWarranty = loading
      this.checkAllLoaded()
    })
    this.sub.servicePackage = this.dataService.loading.servicePackage.subscribe(
      loading => {
        this.loadingServicePackage = loading
        this.checkAllLoaded()
      }
    )

    this.sub.fuelPrices = this.dataService.onVehicleFuelPricesLoaded.subscribe(
      fuelPrices => {
        this.fuelPrices = fuelPrices
      }
    )

    this.sub.onResizePx = this.resizeService.onResizePx.subscribe(size => {
      this.screenSizePx = size
      this.isMobileView()
    })

    this.screenSizePx = this.resizeService.screenSizePx
    this.isMobileView()
  }

  ngOnDestroy (): void {
    this.sharedService.unsubscribe(this.sub)
  }

  setVehicle (): void {
    if (this.vehicles.length > 0) {
      if (
        this.vin != null &&
        this.vehicles.find(vehicle => vehicle.vin === this.vin) == null
      ) {
        void this.router.navigate([this.homepage])
      } else {
        this.loadVehicle(this.vin != null ? this.vin : this.vehicles[0].vin)
      }
    }
  }

  switchRoute (urlParams: Params): void {
    if (urlParams.vehicleTab != null) {
      const param = this.urlParams.vehicleTab
      switch (param) {
        case 'dealer':
          this.currentTab = 'vehicleDealer'
          this.swipeData.currentTab = 2
          break
        case 'details':
          this.currentTab = 'vehicleDetails'
          this.swipeData.currentTab = 1
          break
        case 'vehicle-history':
          this.currentTab = 'vehicleServiceHistory'
          this.swipeData.currentTab = 3
          break
        case 'tracking':
          this.currentTab = 'vehicleTrackingHistory'
          this.swipeData.currentTab = 5
          break
        case 'gallery':
          this.currentTab = 'vehicleGallery'
          this.swipeData.currentTab = 4
          break
        default:
          //   this.sharedService.scrollToTop()
          this.currentTab = 'vehicleGeneral'
          this.swipeData.currentTab = 0
      }
    } else {
      this.sharedService.scrollToTop()
      this.currentTab = 'vehicleGeneral'
      this.swipeData.currentTab = 0
    }
  }

  loadVehicle (vin): void {
    if (this.vehicle?.vin !== vin) {
      this.i = this.vehicles.findIndex(k => k.vin === vin)
      this.vehicle = this.vehicles.find(k => k.vin === vin)
      if (this.vehicle != null) {
        this.getDealerInfo()
        this.setMobileTabs()
      }
    }
  }

  getDealerInfo (): void {
    this.vehicle.dealers = {
      salesDealer: null,
      serviceDealer: null,
      purchasedDealer: null
    }
  }

  showDataIsChangedToast (changed: string): void {
    // dont show notice if dialog or snackbar is open
    if (!this.dialogIsOpen() && this.sharedService.getSnackbarRef() == null) {
      if (this.currentTab === 'vehicleDealer' && changed === 'dealers') {
        if (!this.VehicleDealers?.dealerLoading) {
          this.sharedService.showSnackbar(
            'customerPortal.customer-portal.data-changed',
            null
          )
        }
      }

      if (
        this.currentTab === 'vehicleServiceHistory' &&
        changed === 'documents'
      ) {
        if (!this.VehicleDocuments?.loadingDocuments) {
          this.sharedService.showSnackbar(
            'customerPortal.customer-portal.data-changed',
            null
          )
        }
      }

      if (this.currentTab === 'vehicleGallery' && changed === 'galleries') {
        if (!this.VehicleImages?.loadingGalleries) {
          this.sharedService.showSnackbar(
            'customerPortal.customer-portal.data-changed',
            null
          )
        }
      }

      if (this.currentTab === 'vehicleDetails') {
        switch (changed) {
          case 'vehicleDetails':
          case 'frequentDriver':
            if (!this.VehicleDetails?.loading) {
              this.sharedService.showSnackbar(
                'customerPortal.customer-portal.data-changed',
                null
              )
            }
            break
        }
      }

      if (this.currentTab === 'vehicleGeneral') {
        switch (changed) {
          case 'serviceHistory':
          case 'tires':
          case 'recalls':
          case 'tireAppointmentLink':
            if (this.maintenanceLoaded) {
              this.sharedService.showSnackbar(
                'customerPortal.customer-portal.data-changed',
                null
              )
            }
            break

          case 'leasing':
          case 'warranty':
          case 'servicePackage':
          case 'promotions':
            if (this.leasingWarrantySPLoaded) {
              this.sharedService.showSnackbar(
                'customerPortal.customer-portal.data-changed',
                null
              )
            }
            break
        }
      }
    }
  }

  checkAllLoaded (): void {
    this.maintenanceLoaded = !this.loadingTires
    if (this.remoteConfigService.get('features.recalls')) {
      this.maintenanceLoaded = this.maintenanceLoaded && !this.loadingRecalls
    }

    this.leasingWarrantySPLoaded = true
    if (
      this.hasWarranty &&
      this.remoteConfigService.get('features.warranty') &&
      this.enableEfitData
    ) {
      this.leasingWarrantySPLoaded =
        this.leasingWarrantySPLoaded && !this.loadingWarranty
    }
    if (
      this.sharedService.showServicePackageSection()
    ) {
      this.leasingWarrantySPLoaded =
        this.leasingWarrantySPLoaded && !this.loadingServicePackage
    }
  }

  dialogIsOpen (): boolean {
    return Boolean(this.dialog?.openDialogs?.length > 0)
  }

  isMobileView (): void {
    if (this.screenSizePx > 0) {
      if (this.screenSizePx < 1024) {
        this.showMobileView = true
        this.setMobileTabs()
      } else {
        this.showMobileView = false
      }
      this.cdf.detectChanges()
    }
  }

  setMobileTabs (): void {
    const tabsLength = this.navigationItems.length
    this.swipeData.tabsCount = tabsLength
    if (
      this.hasTracking &&
      this.vehicle?.createdByDataSource === 'customer_portal'
    ) {
      this.swipeData.tabsCount = tabsLength - 1
    }
  }

  swipe (e: TouchEvent, when: string): void {
    const currTab = this.swipeData.currentTab
    this.sharedService.tabSwipe(e, when, this.swipeData)
    if (currTab !== this.swipeData.currentTab) {
      // change route
      const tab = this.tabs[this.swipeData.currentTab]
      void this.router.navigate(['/vehicles', this.vin, tab])
    }
  }

  hasFuelPriceComparison (): boolean {
    return this.dataService.hasFuelPriceComparison(this.vehicle)
  }
}
